'use client'

import { useEffect, useState } from 'react'
import { useSession } from 'next-auth/react'

import {
  AddressServiceSingleton,
  CustomerAddressType,
  editCustomerDeliveryAddress,
  extractTokenFromClientSession,
  getAddressCoordinates,
  isLatitudeAndLongitudeError
} from 'modules/customer'
import Button from 'shared/ui/Button'
import { Modal, ModalDescription, ModalTitle } from 'shared/ui/Modal'

import useCartStore, { useDisplayCart } from '../../../store/cartStore'

import CartAddressOption from './CartAddressOption'

import styles from './CartReservationVerifyAddress.module.scss'

const CartReservationVerifyAddress = () => {
  const [showModal, setShowModal] = useState(false)
  const { refreshCart } = useCartStore()
  const cart = useDisplayCart()
  const session = useSession()
  const token = extractTokenFromClientSession(session)

  useEffect(() => {
    if (
      cart &&
      cart.deliveryAddress &&
      isLatitudeAndLongitudeError(
        cart.deliveryAddress.latitude,
        cart.deliveryAddress.longitude
      )
    ) {
      setShowModal(true)
    }
  }, [cart])

  if (!cart?.deliveryAddress || typeof cart?.deliveryAddress !== 'object') {
    return null
  }

  const handleVerifyAddress = async () => {
    if (
      !isLatitudeAndLongitudeError(
        cart?.deliveryAddress?.latitude,
        cart?.deliveryAddress?.longitude
      )
    ) {
      return setShowModal(false)
    }

    const coordinates = await getAddressCoordinates(
      cart?.deliveryAddress?.postalCode as string,
      cart?.deliveryAddress?.city as string,
      cart?.deliveryAddress?.street as string,
      cart?.deliveryAddress?.houseNumber as string
    )

    if (coordinates && cart?.deliveryAddress) {
      const addressId = cart?.deliveryAddress?.id

      const formValues =
        AddressServiceSingleton.mapDeliveryResponseToFormValues(
          cart?.deliveryAddress
        )
      const payload = AddressServiceSingleton.mapDeliveryFormValuesToPayload(
        formValues,
        CustomerAddressType.delivery
      )

      const payloadWithCoordinates = {
        ...payload,
        latitude: coordinates.latitude,
        longitude: coordinates.longitude
      }

      try {
        await editCustomerDeliveryAddress(addressId, payloadWithCoordinates, token)
        await refreshCart()
        setShowModal(false)
      } catch (error) {
        console.error(error)
        setShowModal(true)
      }
    }
  }

  return (
    <Modal
      id='address-verification-modal'
      open={showModal}
      onClose={() => setShowModal(false)}
      hideDefaultCloseButton
      closeOnBackdropClick={false}
    >
      <ModalTitle>Zweryfikuj adres dostawy</ModalTitle>
      <div className={styles.modalContent}>
        <ModalDescription>
          Czy wybrany adres dostawy jest poprawny? Sprawdź go jeszcze raz:
        </ModalDescription>
        <CartAddressOption
          deliveryAddress={cart?.deliveryAddress}
          checked={true}
          showRemoveDeliveryIcon={false}
        />
        <Button variant='primary' onClick={handleVerifyAddress}>
          Zweryfikuj
        </Button>
      </div>
    </Modal>
  )
}

export default CartReservationVerifyAddress
